import Vue from 'vue';

Vue.filter('capitalize', (string, lowercase = true) => {
  if (!string) return string;
  return (
    string.charAt(0).toUpperCase() +
    (lowercase ? string.slice(1).toLowerCase() : string.slice(1))
  );
});

Vue.filter('uppercase', string => {
  if (!string) return string;
  return string.toUpperCase();
});
